import {AfterViewInit, Component, ViewChild} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { TableModelSuspend, table_data_suspend } from 'src/app/shared/models/data-table-example-items';



@Component({
    selector: 'app-suspend',
    templateUrl: './suspend.component.html',
    styleUrls: ['./suspend.component.less'],
    standalone: false
})

export class SuspendComponent implements AfterViewInit {

  displayedColumns: string[] = ['InstrumentNo','InstrumentDate','InstrumentType','AmountReceived','Adjust'];
  dataSource = new MatTableDataSource<TableModelSuspend>(table_data_suspend);

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}




